import React, { forwardRef, useCallback } from 'react';

type SupportButtonProps<T extends React.ElementType> = {
  component: T
  onClick?: (evt: React.MouseEvent<HTMLElement>) => void
} & Omit<React.ComponentProps<T>, 'component' | 'onClick'>

const SupportButton = forwardRef(function SupportButton<T extends React.ElementType>(
  {
    children,
    onClick,
    component,
    ...rest
  }: SupportButtonProps<T>,
  ref: React.ForwardedRef<HTMLElement>
) {
  const handleClick = useCallback((evt: React.MouseEvent<HTMLElement>) => {
    if (onClick) { onClick(evt); }

    const RedmineHelpdeskWidget = window.RedmineHelpdeskWidget;

    if (RedmineHelpdeskWidget) {
      if (!RedmineHelpdeskWidget.loaded) {
        RedmineHelpdeskWidget.load_schema()
      }

      RedmineHelpdeskWidget.show();

      evt.preventDefault();
    }
  }, [onClick]);

  const Component = component ?? 'button';

  return (
    <Component type="button" {...rest} onClick={handleClick} ref={ref as any}>
      {children}
    </Component>
  )
}) as <T extends React.ElementType>(
  props: SupportButtonProps<T> & { ref?: React.ForwardedRef<HTMLElement> }
) => React.ReactElement;

export default SupportButton
